<template>
  <el-dialog
    title="Adicionar Boleto Avulso"
    @open="iniciar"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    width="400px"
    v-loading="loading"
  >
    <el-form
      :model="boletoAvulso"
      :rules="validacao"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
      style="padding:0;"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Status">
            <el-select v-model="boletoAvulso.status" disabled style="width:100%;">
              <el-option
                v-for="item in statusBoleto"
                :key="item.id"
                :label="item.label"
                :value="item.data"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-col :span="12">
            <el-form-item label="Número">
              <el-input v-model="boletoAvulso.numero" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="boletoAvulso.cliente.id == aluguel.locatario.id ? 12 : 24">
          <el-form-item prop="cliente" label="Cliente">
            <el-select v-model="boletoAvulso.cliente" value-key="id" style="width:100%;">
              <el-option
                v-for="item in clientesContrato"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="boletoAvulso.cliente.id == aluguel.locatario.id">
          <el-form-item label=" ">
            <el-checkbox v-model="acordo">Boleto de Acordo</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="dataVencimento" label="Data de vencimento">
            <el-date-picker
              v-model="boletoAvulso.dataVencimento"
              type="date"
              v-mask="'##/##/####'"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="valor" label="Valor">
            <money v-model="boletoAvulso.valor" v-bind="money" class="el-input__inner" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Multa (%)">
            <money v-model="boletoAvulso.multa" v-bind="percent" class="el-input__inner" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Juros (% a.m.)">
            <money v-model="boletoAvulso.juros" v-bind="percent" class="el-input__inner" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :md="20" :lg="13">
          <el-form-item prop="contaBancaria" label="Conta da imobiliária" style="width: 100%">
            <el-input v-model="boletoAvulso.contaBancaria.nome" disabled style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="4" :lg="3">
          <el-form-item label=" ">
            <el-button
              @click="exibirSelecionarContaImobiliariaDialog()"
              type="primary"
              size="small"
              circle
              class="btn-box-shadow"
            ><i class="el-icon-search"></i></el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Instrução 1">
            <el-input v-model="boletoAvulso.instrucoes1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Instrução 2">
            <el-input v-model="boletoAvulso.instrucoes2"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Instrução 3">
            <el-input v-model="boletoAvulso.instrucoes3"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Instrução 4">
            <el-input v-model="boletoAvulso.instrucoes4"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="boletoIsNovo">
        <el-col :span="24">
          <el-form-item label="Repetir por mais">
            <el-input v-model="boletoAvulso.quantidadeMeses" v-mask="'##'">
              <template slot="append">meses</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Observações">
            <el-input
              v-model="boletoAvulso.observacoes"
              type="textarea"
              style="height: 100px;"
              class="obs-text-area"
              :readonly="!boletoIsNovo"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button
        @click="exibirPagarBoletoAvulsoDialog"
        v-if="exibirBotaoPagarBoleto"
        type="success"
        size="small"
        round
        class="btn-box-shadow"
      >Pagar</el-button>

      <el-button
        @click="cancelarPagamentoHandler"
        v-if="exibirBotaoCancelarPagamentoBoleto"
        type="danger"
        size="small"
        round
        class="btn-box-shadow"
      >Cancelar Pagamento</el-button>

      <el-button
        :disabled="botaoGravarIsDisabled"
        @click="gravarHandler"
        type="primary"
        size="small"
        round
        class="btn-box-shadow"
        v-if="!boletoIsPago"
      >Gravar</el-button>
    </span>

    <app-pagar-boleto-avulso-dialog
      @close="fecharPagarBoletoAvulsoDialog"
      :boletoAvulsoProp="boletoAvulsoSelecionado"
      v-if="boletoAvulsoSelecionado"
      :formaRecebimentoInicial="undefined"
      :visibility="visibilidadePagarBoletoAvulsoDialog"
    />
    <app-selecionar-conta-bancaria-dialog
      apenasBancosHomologados
      @close="fecharSelecionarContaImobiliariaDialog"
      :visibility="visibilidadeSelecionarContaImobiliariaDialog"
      todosOsBancos
    />
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import Util from "../../../util/funcoes.js";
import { STATUS_RECIBO_REPASSE, QUANTIDADE_MAXIMA_REPETICAO_BOLETO } from "../../../util/constantes.js"
import { Money } from "v-money";

import AppPagarBoletoAvulsoDialog from './PagarBoletoAvulsoDialog.vue';
import AppSelecionarContaBancariaDialog from "../../../shared/dialogs/SelecionarContaBancariaDialog.vue";

export default {
  components:{
    Money,
    AppPagarBoletoAvulsoDialog,
    AppSelecionarContaBancariaDialog
  },
  props: {
    boletoAvulsoSelecionado: Object,
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      visibilidadePagarBoletoAvulsoDialog: false,
      visibilidadeSelecionarContaImobiliariaDialog: false,
      
      boletoAvulso: {
        id: 0,
        status: 'EM_ABERTO',
        contaBancaria: {
          id: 0,
          nome: ''
        },
        cliente: {
          id: 0
        }
      },
      
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "R$ ",
        masked: false
      },
      percent: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        sufix: " %",
        masked: false
      },
      validacao: {
        cliente: [{ required: true, validator: this.validadorCliente }],
        dataVencimento: [{ required: true }],
        valor: [{ required: true, validator: this.validadorValor }]
      },

      acordo: false,
    }
  },
  computed: {
    clientesContrato() {
      return this.$store.state.alugueisContratosStore.clientesContrato;
    },
    exibirBotaoPagarBoleto(){
      return this.boletoAvulso.status === "EM_ABERTO" && this.boletoAvulso.id !== 0
    },
    exibirBotaoCancelarPagamentoBoleto(){
      return this.boletoAvulso.status === "PAGO"
    },
    botaoGravarIsDisabled() {
      const remessaFoiGerada = this.boletoAvulso.sequencialRemessa !== undefined;
      const boletoEstaProrrogado = this.boletoAvulso.dataProrrogacao !== undefined;
      
      return remessaFoiGerada || boletoEstaProrrogado;
    },
    util() {
      return Util;
    },
    statusBoleto() {
      return STATUS_RECIBO_REPASSE;
    },
    loading() {
      return this.$store.state.loading;
    },
    boletoIsNovo() {
      return this.boletoAvulso.id == 0;
    },
    boletoIsPago() {
      return this.boletoAvulso.status == 'PAGO';
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore", ["recuperarEnvolvidos","gravarBoletoAvulso","recuperarBoletoAvulso","cancelarPagamentoBoletoAvulso"]),

    async iniciar() {
      await this.handleRecuperarEnvolvidos();

      if(!this.boletoAvulsoSelecionado) {
        return;
      }
      
      await this.handleRecuperarBoleto();
    },

    async handleRecuperarEnvolvidos() {
      const payload = {
        aluguel: {
          id: this.aluguel.id,
        },
      };

      this.showLoading();
      try {
        await this.recuperarEnvolvidos(payload);
      } catch(e) {
        this.$message.error("Não foi possível recuperar os clientes");
        this.fechar();
      }
      this.hideLoading();
    },

    validadorCliente(rule, value, callback) {
      if(this.boletoAvulso.cliente.nome) {
        return callback();
      } else {
        return callback(new Error());
      }
    },

    validadorValor(rule, value, callback) {
      if(value > 0) {
        return callback();
      } else {
        return callback(new Error());
      }
    },

    handleRecuperarBoleto() {
      this.showLoading();
      this.recuperarBoletoAvulso({ id: this.boletoAvulsoSelecionado.id })
        .then(resultado => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.boletoAvulso = resultado.item
              if(resultado.item.tipoBoleto == 'ACORDO') { this.acordo = true }
              break;
            default:
              this.$message.error(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se com o servidor");
        });
    },

    gravarHandler() {
      this.boletoAvulso.aluguel = { id: this.aluguel.id }
      this.$refs['form'].validate(elformValidation => {
        const formIsInvalid = !elformValidation;
        if(formIsInvalid) {
          this.exibirAlerta("Preencha todos os campos obrigatórios");
          return;
        }
        if(this.boletoAvulso.quantidadeMeses > QUANTIDADE_MAXIMA_REPETICAO_BOLETO) {
          this.exibirAlerta('Não é possível repetir o boleto por mais de 60 meses.');
          return;
        }
        if(this.boletoAvulso.contaBancaria.id == 0) {
          this.exibirAlerta('Selecione a conta bancária');
          return;
        }
          this.gravar();
      })
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'error' });
    },

    gravar() {
      this.showLoading();
      if(this.acordo && (this.boletoAvulso.cliente.id == this.aluguel.locatario.id)) 
      { this.boletoAvulso.tipoBoleto = 'ACORDO' }
      else { this.boletoAvulso.tipoBoleto = 'OUTROS' }
      this.gravarBoletoAvulso(this.boletoAvulso)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.exibirAlerta(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    
    exibirPagarBoletoAvulsoDialog() { 
      this.visibilidadePagarBoletoAvulsoDialog = true 
    },
    fecharPagarBoletoAvulsoDialog(status) {
      this.visibilidadePagarBoletoAvulsoDialog = false;
      if(status === "SUCESSO"){
        this.fechar();
      }
    },
    cancelarPagamentoHandler(){
      this.showLoading();
        this.cancelarPagamentoBoletoAvulso({ id: this.boletoAvulso.id, aluguel: { id: this.aluguel.id } })
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.fechar();
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
    },

    exibirSelecionarContaImobiliariaDialog() {
      this.visibilidadeSelecionarContaImobiliariaDialog = true;
    },
    fecharSelecionarContaImobiliariaDialog(contaBancaria) {
      this.boletoAvulso.contaBancaria = contaBancaria
      this.visibilidadeSelecionarContaImobiliariaDialog = false;
    },
    reset(){
      this.boletoAvulso = {
        id: 0,
        status: 'EM_ABERTO',
        contaBancaria: {
          id: 0,
          nome: ''
        },
        cliente: {
          id: 0
        }
      },

      this.acordo = false;
    },
    fechar() {
      this.reset()
      this.$emit('close');
    }, 
  }
}
</script>
